import {userGuard} from "~/router/middleware/guards";
import TranscribeSearch from "~/components/pages/stat/speechAnalysis/TranscribeSearch";
import WiretappingRate from "~/components/pages/stat/speechAnalysis/WiretappingRate";
import ProjectService from "~/components/pages/stat/speechAnalysis/ProjectService";
import SpeechAnalysisReport from "~/components/pages/stat/speechAnalysis/SpeechAnalysisReport";
import SpeechAnalysisReportCustomer from "~/components/pages/stat/speechAnalysis/SpeechAnalysisReportCustomer";
import SpeechAnalysisCall from "~/components/pages/stat/speechAnalysis/SpeechAnalysisCall";

export default [
    {
        path: '/stat/speech-analysis/transcribe-search',
        name: 'transcribe-search',
        component: TranscribeSearch,
        middleware: {
            permissions: ['statiz.transcribe-search.report']
        },
        beforeEnter: userGuard
    },
    {
        path: '/stat/speech-analysis/wiretapping-rate',
        name: 'wiretapping-rate',
        component: WiretappingRate,
        middleware: {
            permissions: ['statiz.wiretapping-rate']
        },
        beforeEnter: userGuard
    },
    {
        path: '/stat/project-service',
        name: 'project-service',
        component: ProjectService,
        middleware: {
            permissions: ['statiz.wiretapping-rate']
        },
        beforeEnter: userGuard
    },
    {
        path: '/stat/speech-analysis/calls/:uid',
        name: 'SpeechAnalysisCall',
        component: SpeechAnalysisCall,
        middleware: {
            permissions: ['statiz.wiretapping-rate']
        },
        beforeEnter: userGuard
    },

    {
        path: '/stat/speech-analysis/report',
        name: 'speech-analysis.report',
        component: SpeechAnalysisReport,
        middleware: {
            permissions: ['statiz.wiretapping-rate']
        },
        beforeEnter: userGuard
    },
    {
        path: '/stat/speech-analysis/report_customer',
        name: 'speech-analysis.report_customer',
        component: SpeechAnalysisReportCustomer,
        middleware: {
            permissions: ['statiz.wiretapping-rate']
        },
        beforeEnter: userGuard
    },
    {
        path: '/stat/speech-analysis/report/wire/:username',
//        path: '/stat/speech-analysis/report/wire',
        props: true,
        // props: route =>({
        //     query: route.query.q
        // }),
        name: 'SpeechAnalysisReportWire',
        component: SpeechAnalysisReport,
        middleware: {
            permissions: ['statiz.wiretapping-rate']
        },
        beforeEnter: userGuard
    },
]


